/** Platform AI agents — single source for agent ids and display names. Mirrors backend PlatformAiAgentDefinitions until a catalog API exists. */
export const PLATFORM_AI_AGENTS = {
  default: {
    aiAgentId: "zeno",
    displayName: "Zeno",
    fullCaps: "ZENO"
  },
};

/** Matches MessageSenderTypeEnum values (HUMAN=1, AI=2, SYSTEM=3). */
export const MESSAGE_SENDER_TYPE = {
  HUMAN: 1,
  AI: 2,
  SYSTEM: 3,
};

/** Matches MessageSourceEnum.AUTO_REPLY_BY_AI (status 23). */
export const SENT_VIA_AI_AUTO_REPLY = 23;
export const SENT_VIA_AI_AUTO_REPLY_SOURCE = "auto_reply_by_ai";

export function isAiAutoReplyMessage(message) {
  const sentVia = message?.sent_via ?? message?.sentVia;
  return (
    sentVia === SENT_VIA_AI_AUTO_REPLY ||
    sentVia === SENT_VIA_AI_AUTO_REPLY_SOURCE ||
    sentVia === String(SENT_VIA_AI_AUTO_REPLY)
  );
}

/**
 * Resolve display name + avatar for a message/log row.
 * Gate: sent_via is AI → look up catalog via aiAgentId; fall back to reply_by on the row.
 */
export function resolveMessageAuthor(message) {
  if (!message) {
    return { name: "", imageUrl: "", isAiAgent: false, aiAgentId: null };
  }

  const messageAuthor = {
    name: message.reply_by || message.senderName || "",
    imageUrl: message.sender_url || message.senderPhoto || "",
    isAiAgent: false,
    aiAgentId: null,
  };

  // If the message is an AI auto-reply, override the message author to the AI agent
  if (isAiAutoReplyMessage(message)) {
    const agent =
      PLATFORM_AI_AGENTS[message.aiAgentId] || PLATFORM_AI_AGENTS.default;
    messageAuthor.isAiAgent = true;
    messageAuthor.aiAgentId = agent.aiAgentId;
    messageAuthor.name = agent.displayName;
  }
  return messageAuthor;
}
